import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "IMPORT_CSV_FORM", {
  RESET_FILE: "Reset actual file: {{fileName}}",
  UPLOAD_BUTTON: "Upload csv file",
  SUBMIT_BUTTON: "Submit",
});
